var sw  = require('js/lib/sw');
var $   = require('js/sw-jquery/sw-jquery');
var url = require('url');
var signupDialog = require('js/lib/notifications/sw-signup-dialog');

$(document).ready(function() {
  var queryData = url.parse(window.location.href, true).query;
  if (!$.isEmptyObject(queryData.followUrl)) {
    if (!sw.data.user.isLoggedIn) {
      var loginEventName = 'sw-login-complete.profile-follow';
      sw.on(loginEventName, function () {
        window.location.reload();
        sw.off(loginEventName);
      });
      signupDialog.openLogInSignUpDialog('login', null, 'follow_designer', null, 'event:' + loginEventName);
    } else {
      window.location = queryData.followUrl;
    }
  }
});
